module.exports = __webpack_public_path__ + "img/content9-2.6006baf7.webp";